import { render, staticRenderFns } from "./dailyConsumption .vue?vue&type=template&id=4d28b350&scoped=true&"
import script from "./dailyConsumption .vue?vue&type=script&lang=js&"
export * from "./dailyConsumption .vue?vue&type=script&lang=js&"
import style0 from "./dailyConsumption .vue?vue&type=style&index=0&id=4d28b350&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28b350",
  null
  
)

export default component.exports